"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var preact_transitioning_1 = require("preact-transitioning");
var config_1 = require("./config");
function ItemColorExample() {
    var _a = (0, hooks_1.useState)(0), colorItem = _a[0], setColorItem = _a[1];
    var switchPrevColor = function () {
        setColorItem(function (prevColorItem) { return Math.max(0, prevColorItem - 1); });
    };
    var switchNextColor = function () {
        setColorItem(function (prevColorItem) { return Math.min(config_1.COLORS.length - 1, prevColorItem + 1); });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "container", children: [(0, jsx_runtime_1.jsx)("button", { onClick: switchNextColor, type: "button", children: "Next item color" }), ' ', (0, jsx_runtime_1.jsx)("button", { onClick: switchPrevColor, type: "button", children: "Prev item color" }), (0, jsx_runtime_1.jsx)("hr", {}), (0, jsx_runtime_1.jsx)(preact_transitioning_1.TransitionGroup, { duration: config_1.DURATION, exit: false, children: (0, jsx_runtime_1.jsx)(preact_transitioning_1.CSSTransition, { classNames: "fade", children: (0, jsx_runtime_1.jsx)("div", { className: "item", style: { background: config_1.COLORS[colorItem] }, children: config_1.COLORS[colorItem] }) }, colorItem) })] }));
}
exports.default = ItemColorExample;
